// auth
export const AUTH_STORE_TOKEN = "AUTH_STORE_TOKEN";
export const AUTH_FORGET_TOKEN = "AUTH_FORGET_TOKEN";
export const AUTH_SHOW_POPUP_RESTORE_PASSWORD = "AUTH_SHOW_POPUP_RESTORE_PASSWORD";
export const AUTH_SHOW_POPUP_NEW_PASSWORD = "AUTH_SHOW_POPUP_NEW_PASSWORD";
export const AUTH_LOADING_REGISTRATION = "AUTH_LOADING_REGISTRATION";
export const AUTH_RESTORE_PASSWORD_LOADING = "AUTH_RESTORE_PASSWORD_LOADING";
export const AUTH_SET_NEW_PASSWORD_LOADING = "AUTH_SET_NEW_PASSWORD_LOADING";
export const AUTH_LOADING_SING_IN = "AUTH_LOADING_SING_IN";

export const SHOW_GLOBAL_LOADER = "SHOW_GLOBAL_LOADER";
export const FIX_PAGE = "FIX_PAGE";
// settings
export const SET_TRANSLATIONS = "SET_TRANSLATIONS";
export const SET_CATALOG_MENU_LOADING = "SET_CATALOG_MENU_LOADING";
export const SET_CATALOG_MENU = "SET_CATALOG_MENU";
export const SET_SETTING = "SET_SETTING";
export const SET_COUNTRIES = "SET_COUNTRIES";
export const GET_COUNTRIES_LOADING = "GET_COUNTRIES_LOADING";
export const SET_SERVER_TIME = "SET_SERVER_TIME";
// system
export const SET_CUSTOM_BREADCRUMBS_LIST = "SET_CUSTOM_BREADCRUMBS_LIST";
export const RESET_CUSTOM_BREADCRUMBS_LIST = "RESET_CUSTOM_BREADCRUMBS_LIST";
export const CHANGE_MOBILE_MENU = "CHANGE_MOBILE_MENU";
// config
export const GET_CONFIG_LOADING = "GET_CONFIG_LOADING";
export const SET_CONFIG = "SET_CONFIG";
// profile
export const SET_USER_DATA = "SET_USER_DATA";
export const LOADING_USER_DATA = "LOADING_USER_DATA";
export const UPDATE_USER_DATA_LOADING = "UPDATE_USER_DATA_LOADING";

// header
export const HEADER_COURSES_SHOW_TOOLTIP = "HEADER_COURSES_SHOW_TOOLTIP";
export const HEADER_NOTIFICATION_SHOW_TOOLTIP = "HEADER_NOTIFICATION_SHOW_TOOLTIP";
export const HEADER_PROFILE_SHOW_TOOLTIP = "HEADER_PROFILE_SHOW_TOOLTIP";
export const HEADER_NOTIFICATION_SET_LIST = "HEADER_NOTIFICATION_SET_LIST";
export const HEADER_NOTIFICATION_REQUEST_LOADING = "HEADER_NOTIFICATION_REQUEST_LOADING";
export const CHANGE_OPEN_SEARCH = "CHANGE_OPEN_SEARCH";
export const CHANGE_HOMEWORK_HEADER = "CHANGE_HOMEWORK_HEADER";
export const HEADER_NOTIFICATION_REMOVE = "HEADER_NOTIFICATION_REMOVE";
export const HEADER_SET_NOTIFICATIONS_READED = "HEADER_SET_NOTIFICATIONS_READED";
export const HEADER_SET_NOTIFICATIONS_REMOVE_ALL = "HEADER_SET_NOTIFICATIONS_REMOVE_ALL";

// courses meetups
export const MEETUPS_REQUEST_STATUS = "MEETUPS_REQUEST_STATUS";
export const MEETUPS_SET_LIST = "MEETUPS_SET_LIST";
export const MEETUPS_SET_ITEM = "MEETUPS_SET_ITEM";
export const MEETUPS_ITEM_REQUEST_STATUS = "MEETUPS_ITEM_REQUEST_STATUS";

// popups
export const CHANGE_POPUP_TRAILER = "CHANGE_POPUP_TRAILER";

// main
export const SET_LIST = "SET_LIST";
export const CHANGE_LOADING = "CHANGE_LOADING";
export const CHANGE_SKIP = "CHANGE_SKIP";
export const SET_LIST_LENGTH = "SET_LIST_LENGTH";
export const CHANGE_CATEGORY = "CHANGE_CATEGORY";
export const SET_ITEM = "SET_ITEM";
export const CHANGE_INDEX = "CHANGE_INDEX";
export const CHANGE_DATE = "CHANGE_DATE";
export const SET_CATEGORIES = "SET_CATEGORIES";
export const CHANGE_CATEGORIES_LOADING = "CHANGE_CATEGORIES_LOADING";
export const CHANGE_LIST_ITEM_LOADING = "CHANGE_LIST_ITEM_LOADING";

//action-plan
export const CHANGE_LAST_STEP_ID = "CHANGE_LAST_STEP_ID";
export const CHANGE_PROGRESS_LOADING = "CHANGE_PROGRESS_LOADING";
export const CHANGE_USER_ACTION_PLAN_STATUS = "CHANGE_USER_ACTION_PLAN_STATUS";

//test
export const CHANGE_LIST_LOADING = "CHANGE_LIST_LOADING";
export const CHANGE_STEP = "CHANGE_STEP";
export const CHANGE_HEADER = "CHANGE_HEADER";
export const CHANGE_LOADING_TEST = "CHANGE_LOADING_TEST";
export const SET_CURRENT_QUESTION = "SET_CURRENT_QUESTION";
export const CHANGE_LOADING_REPORT = "CHANGE_LOADING_REPORT";
export const SET_REPORT_RESULT = "SET_REPORT_RESULT";
export const CHANGE_POPUP_CANCEL_TEST = "CHANGE_POPUP_CANCEL_TEST";
export const CHANGE_SHOW_POPUP_SING_IN_RESULT = "CHANGE_SHOW_POPUP_SING_IN_RESULT";
export const SET_LIST_COUNT = "SET_LIST_COUNT";

export const SET_TIMEZONES = "SET_TIMEZONES";
export const GET_TIMEZONES_LOADING = "GET_TIMEZONES_LOADING";

export const SET_COUNTRY = "SET_COUNTRY";

export const POPUP_TEXT_CONTENT = "POPUP_TEXT_CONTENT";
export const SHOW_POPUP_TEXT_CONTENT = "SHOW_POPUP_TEXT_CONTENT";
